module.exports = __webpack_public_path__ + "img/qgfx.10f73e69.png";